import state from './moduleLiveMapState.js'
import mutations from './moduleLiveMapMutations.js'
import actions from './moduleLiveMapActions.js'
import getters from './moduleLiveMapGetters.js'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
